import React, {useState, useRef, useCallback, useEffect} from 'react';
import { Link, useHistory } from "react-router-dom";
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule, GroupItem
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import { resetPassword } from '../../api/auth';
import './reset-password-form.scss';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import {TextBox} from "devextreme-react";

const notificationText = 'Мы отправили Вам ссылку для восстановления пароля. Проверьте свой почтовый ящик.';

const ResetPasswordForm = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const formData = useRef({});
  let [cod, setCod] = useState('')
  const captchaSymbols = 6
  const backrgoundCaptcha = process.env.REACT_APP_NAME_ENV === 'tatenergosbyt' ? '#FFF4E8' : '#FFFFFF';

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();

    if (validateCaptcha(cod) !== true) {
      notify('Неверный код', 'error', 2000);
      loadCaptchaEnginge(captchaSymbols, backrgoundCaptcha, 'black', 'lower')
      setCod('')
      return;
    }
    loadCaptchaEnginge(captchaSymbols, backrgoundCaptcha, 'black', 'lower')
    setCod('')

    const { email } = formData.current;
    setLoading(true);

    const result = await resetPassword(email);
    setLoading(false);

    if (result.isOk) {
      history.push('/login');
      notify(result.message || notificationText, 'success', 5000);
    } else {
      notify(result.message, 'error', 5000);
    }
  }, [history, cod, backrgoundCaptcha]);

  const valueChanged = useCallback((e) => {
    setCod(e.value);
  }, []);

  useEffect(() => {
      setTimeout(() => loadCaptchaEnginge(captchaSymbols, backrgoundCaptcha, 'black', 'lower'), 100)
  },[backrgoundCaptcha])

  const onContentReady = () => {
    setTimeout(() => loadCaptchaEnginge(captchaSymbols, backrgoundCaptcha, 'black', 'lower'), 100)
  }

  return (
    <form className={'reset-password-form'} onSubmit={onSubmit}>
      <Form
          formData={formData.current}
            disabled={loading}
            labelMode="floating"
          onContentReady={onContentReady}
      >
        <Item
          dataField={'email'}
          editorType={'dxTextBox'}
          editorOptions={emailEditorOptions}
        >
          <RequiredRule message="Email задан неверно" />
          <EmailRule message="Email задан неверно" />
          <Label visible={false} />
        </Item>

            <GroupItem colCount={1} >
              <Item>
                <div className="captcha">
                  <div className="">
                    <LoadCanvasTemplate reloadText='Обновить' reloadColor='#ED7E31' />
                  </div>
                </div>
              </Item>
              <Item cssClass={'h-100'}>
                <div className="captcha-text">
                  <div className="">
                    <TextBox
                        dataField={'kod'}
                        id="user_captcha_input"
                        labelMode='floating'
                        label={'Код с картинки'}
                        onValueChanged={valueChanged}
                        valueChangeEvent="keyup"
                        value={cod}
                    />
                  </div>
                </div>
              </Item>
            </GroupItem>

        <ButtonItem>
          <ButtonOptions
            elementAttr={submitButtonAttributes}
            width={'100%'}
            type={'default'}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text tatsbyt-text-bold">
              {
                loading
                  ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                  : 'Восстановить пароль'
              }
            </span>
          </ButtonOptions>
        </ButtonItem>
        <Item>
          <div className={'login-link'}>
            <Link to={'/login'}>Войти</Link>
          </div>
        </Item>
      </Form>
    </form>
  );
}

const emailEditorOptions = { stylingMode: 'filled', placeholder: 'Email', mode: 'email' };
const submitButtonAttributes = { class: 'submit-button' };

export default ResetPasswordForm
